import createIcon from '../../createIcon';

/**
 * @component @name BrowserNotSupported
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTI1MSA1LjMwOTg4VjE1LjgwOTlMMjEuNDc1MSAxNy43NTk5QzIxLjUwNTEgMTcuNjA5OSAyMS41MjUxIDE3LjQ1OTkgMjEuNTI1MSAxNy4zMDk5VjUuMzA5ODhDMjEuNTI1MSA0LjIwOTg4IDIwLjYyNTEgMy4zMDk4OCAxOS41MjUxIDMuMzA5ODhINy4wMjUxTDkuMDI1MSA1LjMwOTg4SDE5LjUyNTFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy43NDUxIDIuNjI5ODhMMi40NzUxIDMuODk5ODhMMy41MjUxIDQuOTQ5ODhWMTcuMzA5OUMzLjUyNTEgMTguNDA5OSA0LjQyNTEgMTkuMzA5OSA1LjUyNTEgMTkuMzA5OUgxNy44ODUxTDE5Ljk0NTEgMjEuMzY5OUwyMS4yMTUxIDIwLjA5OTlMMy43NDUxIDIuNjI5ODhaTTUuNTI1MSAxNy4zMDk5VjYuOTQ5ODhMMTUuODg1MSAxNy4zMDk5SDUuNTI1MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrowserNotSupported = createIcon('BrowserNotSupported', [
  [
    'path',
    {
      d: 'M19.5251 5.30988V15.8099L21.4751 17.7599C21.5051 17.6099 21.5251 17.4599 21.5251 17.3099V5.30988C21.5251 4.20988 20.6251 3.30988 19.5251 3.30988H7.0251L9.0251 5.30988H19.5251Z',
      key: '1jjwz0',
    },
  ],
  [
    'path',
    {
      d: 'M3.7451 2.62988L2.4751 3.89988L3.5251 4.94988V17.3099C3.5251 18.4099 4.4251 19.3099 5.5251 19.3099H17.8851L19.9451 21.3699L21.2151 20.0999L3.7451 2.62988ZM5.5251 17.3099V6.94988L15.8851 17.3099H5.5251Z',
      key: '11x5au',
    },
  ],
]);

export default BrowserNotSupported;
